import { FC, Fragment } from 'react'
import RecruitListItemDesktop from './desktop/component/RecruitListItem.desktop'
import RecruitListItemMobile from './mobile/component/RecruitListItem.mobile'

type TProps = {
  isMobile?: boolean
  skeletonCount?: number
}

// Todo: image size fix
const RecruitListSkeleton: FC<TProps> = ({ isMobile, skeletonCount = 20 }) => {
  return (
    <>
      {new Array(skeletonCount).fill('').map((_, index) => {
        return (
          <Fragment key={`recruit-list-skeleton-${index}-isMobile-${isMobile}`}>
            {isMobile ? (
              <RecruitListItemMobile isLoading />
            ) : (
              <RecruitListItemDesktop isLoading />
            )}
          </Fragment>
        )
      })}
    </>
  )
}

export default RecruitListSkeleton
